<template>
    <Body
        class="bg-noise relative flex min-h-screen flex-col scroll-smooth bg-black bg-gradient-to-b from-accent-400/10 via-accent-400/15 via-20% to-accent-400/10 to-95% p-0 font-gilroy text-ash-200">
        <div class="relative z-10">
            <AppHeader />

            <slot />

            <CookieContainer />
            <AppFooter />
            <ScrollToTopButton />
            <MessangersButton />
            <AppToast />

            <div
                v-if="isShowCartButton"
                class="pointer-events-none fixed top-40 z-40 w-screen">
                <NuxtLink
                    to="/cart/"
                    aria-label="Перейти в корзину"
                    class="pointer-events-auto relative ml-auto block max-w-20 cursor-pointer rounded-l-full border-y border-l border-ash-200 bg-white/20 py-5 pl-6 pr-5 backdrop-blur-sm transition-all duration-200 hover:bg-accent-400/40">
                    <AtomIcon
                        name="cart"
                        class="size-9" />

                    <Transition name="slide-up">
                        <span
                            v-if="isReady && totalItems"
                            class="absolute left-0 top-0 flex h-6 min-w-6 items-center justify-center rounded-full bg-white px-1 text-16/148 font-semibold leading-none text-accent">
                            {{ totalItems > 999 ? '999+' : totalItems }}
                        </span>
                    </Transition>
                </NuxtLink>
            </div>
        </div>

        <div
            class="pointer-events-none fixed left-0 top-10 z-0 size-full w-screen opacity-50 max-lg:hidden">
            <picture>
                <source
                    type="image/webp"
                    srcset="/assets/images/ui/other/webp/screen-stars.webp" />

                <img
                    class="mx-auto size-full object-contain"
                    loading="eager"
                    fetchpriority="high"
                    decoding="async"
                    src="/assets/images/ui/other/jpg-png/screen-stars.png"
                    alt="" />
            </picture>
        </div>

        <IncludeModals />
    </Body>
</template>

<script setup lang="ts">
import AtomIcon from '~/components/atom/atom-icon/AtomIcon.vue'
import AppToast from '~/components/layouts/app-toast/AppToast.vue'
import AppFooter from '~/components/layouts/footer/AppFooter.vue'
import AppHeader from '~/components/layouts/header/AppHeader.vue'
import IncludeModals from '~/components/layouts/include-modals/IncludeModals.vue'
import MessangersButton from '~/components/layouts/messangers-button/MessangersButton.vue'
import ScrollToTopButton from '~/components/layouts/scroll-to-top-button/ScrollToTopButton.vue'
import CookieContainer from '~/components/particles/cookie-container/CookieContainer.vue'

import gilroyMediumFontUrl from '~/assets/font/Gilroy-Medium.woff2?url'
import gilroyRegularFontUrl from '~/assets/font/Gilroy-Regular.woff2?url'
import gilroySemiboldFontUrl from '~/assets/font/Gilroy-Semibold.woff2?url'

const route = useRoute()
const { isReady, totalItems } = useCart()

const isShowCartButton = computed(() => {
    return isCromi() && !['cart', 'create-order'].includes(route.name as string)
})

onMounted(() => {
    document.addEventListener('touchstart', () => {
        if (!document.querySelectorAll('video')) return
        document.querySelectorAll('video').forEach((video) => video.play())
    })
})

if (route.name !== 'direction') {
    useSchemaOrg([
        {
            ...getSeoOrganization(),
            isPartOf: undefined,
        },
    ])
}

const config = useRuntimeConfig()
const baseUrl = config.public.website

type FontPreloadLink = {
    rel: 'preload'
    as: 'font'
    href: string
    type: 'font/woff2'
    crossorigin: 'anonymous'
}

const fontPreloadLinks: FontPreloadLink[] = [
    {
        rel: 'preload',
        as: 'font',
        href: gilroyRegularFontUrl,
        type: 'font/woff2',
        crossorigin: 'anonymous',
    },
    {
        rel: 'preload',
        as: 'font',
        href: gilroyMediumFontUrl,
        type: 'font/woff2',
        crossorigin: 'anonymous',
    },
    {
        rel: 'preload',
        as: 'font',
        href: gilroySemiboldFontUrl,
        type: 'font/woff2',
        crossorigin: 'anonymous',
    },
]

useHead(() => ({
    link: [
        ...fontPreloadLinks,
        {
            rel: 'canonical' as const,
            href: `https://www.${baseUrl}${route.path == '/' ? '' : route.path}`,
        },
    ],
}))
</script>
